import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mobile-arrow-down",
  "use": "icon-mobile-arrow-down-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-mobile-arrow-down\">\n    <path d=\"m1.24 5.225 6.8 6.801 6.802-6.8h-1.415L8.041 10.61 2.655 5.225z\" fill=\"#DDD\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol